import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ScoreBadge from '../../../../shared-components/ScoreBadge';
import styles from './enrichment-top-bar.module.sass';
import { Col, Row, Button, Typography, Tooltip, Modal } from 'antd';
import { CopyOutlined, TwitterCircleFilled } from '@ant-design/icons';
import {
  infoNotification,
  showNotification,
} from '../../../../shared-components/Notifications';
import LoadingSkeleton from '../../../../shared-components/LoadingSkeleton';
import EnrichmentSaveToButton from '../EnrichmentSaveToButton';
import { STATUS } from '../../../../redux/constants';
import { JSONViewer } from '../../../../shared-components/JSONViewer';

function EnrichmentTopBar({
  oldData,
  statusOld,
  newData,
  statusNew,
  ARecordsDomainEnrichmentData,
  ARecordsDomainEnrichmentStatus,
  AAAARecordsDomainEnrichmentData,
  AAAARecordsDomainEnrichmentStatus,
  CNAMERecordsDomainEnrichmentData,
  CNAMERecordsDomainEnrichmentStatus,
  MXRecordsDomainEnrichmentData,
  MXRecordsDomainEnrichmentStatus,
  NSRecordsDomainEnrichmentData,
  NSRecordsDomainEnrichmentStatus,
  SOARecordsDomainEnrichmentData,
  SOARecordsDomainEnrichmentStatus,
  TXTRecordsDomainEnrichmentData,
  TXTRecordsDomainEnrichmentStatus,
  whoisData,
  whoisStatus,
  type,
  props,
}) {
  const { Title, Paragraph, Text } = Typography;
  let newEnrichmentData = undefined;
  const [copyRawDisabled, setCopyRawDisabled] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }
  const q = useQuery();

  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleOk = () => {
    copyRawData(
      oldData,
      newData?.response,
      ARecordsDomainEnrichmentData?.response,
      AAAARecordsDomainEnrichmentData?.response,
      CNAMERecordsDomainEnrichmentData?.response,
      MXRecordsDomainEnrichmentData?.response,
      NSRecordsDomainEnrichmentData?.response,
      SOARecordsDomainEnrichmentData?.response,
      TXTRecordsDomainEnrichmentData?.response,
      whoisData?.response,
    );
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  if (type === 'domain') {
    newEnrichmentData = newData?.response;
  } else if (type === 'ipv4') {
    if (newData?.response?.ip2asn) {
      newEnrichmentData = newData?.response?.ip2asn?.[0];
    }
  }

  useEffect(() => {
    if (type === 'domain') {
      if (
        statusOld === 'loaded' &&
        statusNew === 'loaded' &&
        ARecordsDomainEnrichmentStatus === 'loaded' &&
        AAAARecordsDomainEnrichmentStatus === 'loaded' &&
        CNAMERecordsDomainEnrichmentStatus === 'loaded' &&
        MXRecordsDomainEnrichmentStatus === 'loaded' &&
        NSRecordsDomainEnrichmentStatus === 'loaded' &&
        SOARecordsDomainEnrichmentStatus === 'loaded' &&
        TXTRecordsDomainEnrichmentStatus === 'loaded' &&
        whoisStatus === 'loaded'
      ) {
        setCopyRawDisabled(false);
      }
    } else if (type === 'ipv4') {
      if (statusOld === 'loaded' && statusNew === 'loaded') {
        setCopyRawDisabled(false);
      }
    }
  }, [
    type,
    statusOld,
    statusNew,
    ARecordsDomainEnrichmentStatus,
    AAAARecordsDomainEnrichmentStatus,
    CNAMERecordsDomainEnrichmentStatus,
    MXRecordsDomainEnrichmentStatus,
    NSRecordsDomainEnrichmentStatus,
    SOARecordsDomainEnrichmentStatus,
    TXTRecordsDomainEnrichmentStatus,
    whoisStatus,
  ]);

  function copyToClipboard(text) {
    navigator.clipboard.writeText(text);
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function copyRawData(...props) {
    navigator.clipboard.writeText(JSON?.stringify(props));
    showNotification(
      infoNotification({
        statusCode: 100,
        message: 'Copied to clipboard!',
      }),
    );
  }

  function PrettyPrintJson(...props) {
    return <JSONViewer containerClassName={'enrichment-viewer'} data={props} />;
  }

  function shareOnTwitter(ioc) {
    const text = encodeURIComponent(
      `Possible threat alert: ${ioc} found on `.replaceAll('.', '[.]'),
    );
    const url = encodeURIComponent('https://www.silentpush.com');
    const via = 'silentpush';
    window.open(
      `https://twitter.com/intent/tweet?text=${text}&url=${url}&via=${via}`,
      '_blank',
    );
  }

  if (statusNew === STATUS.LOADED) {
    return (
      <div className={styles.enrichment_top_bar}>
        <div className={styles.toolbar}>
          <div className={styles.iocName}>
            <Tooltip title="Single metric incorporating the source score, enriched indicator score and custom indicator score">
              <Text className={styles.empty_text}>&nbsp;</Text>
              <ScoreBadge
                loading={statusOld === STATUS.LOADING}
                score={oldData?.total_score ? oldData?.total_score : 0}
                scoreTextRecolor={false}
                scoreProgressRecolor={false}
                boxBordered={false}
              />
            </Tooltip>
            <Tooltip
              title={
                q?.get('name')?.length > 40
                  ? q?.get('name')
                  : 'The name of the observable'
              }
              placement="bottom"
            >
              <Title level={2} className={styles.bar_title}>
                {q?.get('name')?.length > 40
                  ? q?.get('name')?.substr(0, 40) + '...'
                  : q?.get('name')}
              </Title>
            </Tooltip>
          </div>
          <div className={styles.actions}>
            <div className={styles.icons}>
              <Tooltip title="The type of the observable can be IP address, domain, or url">
                <Button className={styles.type_button}>
                  {type === 'domain' && <Paragraph>Domain</Paragraph>}
                  {type === 'ipv4' && <Paragraph>IP</Paragraph>}
                </Button>
              </Tooltip>

              <Tooltip title="Copy observable's name">
                <Button
                  icon={<CopyOutlined />}
                  shape="round"
                  onClick={() => copyToClipboard(q?.get('name'))}
                ></Button>
              </Tooltip>

              <Tooltip title="Share observable on Twitter">
                <Button
                  icon={<TwitterCircleFilled />}
                  shape="round"
                  onClick={() => shareOnTwitter(q?.get('name'))}
                ></Button>
              </Tooltip>
            </div>

            <div className={styles.buttons}>
              <Button
                className={styles.basicRawDataButton}
                loading={!(statusOld === 'loaded' && statusNew === 'loaded')}
                type="link"
                disabled={copyRawDisabled}
                onClick={showModal}
              >
                Basic Raw Data
              </Button>

              <Tooltip
                title={
                  props?.mySubscriptionPlanStatus === STATUS.LOADED &&
                  props?.mySubscriptionPlan?.has_access_to_sources ? null : (
                    <>
                      Saving observables in the feed or collection is not part
                      of this subscription plan. To upgrade your subscription
                      contact us at{' '}
                      <a target="_blank" href="mailto:sales@silentpush.com">
                        sales@silentpush.com
                      </a>
                      .
                    </>
                  )
                }
                placement="top"
              >
                <EnrichmentSaveToButton
                  props={props}
                  type={type}
                  mergeAPIEnrichmentData={oldData}
                />
              </Tooltip>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <Modal
            title="Raw Data"
            width={800}
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={[
              <Button key="back" onClick={handleCancel}>
                Cancel
              </Button>,
              <Button key="submit" type="primary" onClick={handleOk}>
                Copy Raw Data
              </Button>,
            ]}
          >
            {type === 'domain'
              ? PrettyPrintJson(oldData, newData?.response, whoisData?.response)
              : PrettyPrintJson(oldData, newData?.response)}
          </Modal>
        )}
      </div>
    );
  } else {
    return (
      <div className={styles.enrichment_top_bar}>
        <Row gutter={16} className="mt-1">
          <Col span={6}>
            <LoadingSkeleton />
          </Col>
          <Col span={8}>
            <LoadingSkeleton />
          </Col>
        </Row>
      </div>
    );
  }
}

export default EnrichmentTopBar;
